<template>
    <div class="cs-offerwall__filterOptionsComponent" v-if="showFilterOptions && !!selectedFilters" >
        <div class="cs-offerwall__filterOptionsComponentBox">
            <div class="cs-offerwall__filterOptionsComponentBoxHeader">
                <div class="cs-offerwall__filterOptionsComponentBoxTitle">{{dictionary.title}}</div>
                <div class="cs-offerwall__filterOptionsComponentBoxClose" v-on:click="$emit('closeFilterOptionsComponent')"> 
                    <img src="https://comprasocial.me/wp-content/uploads/2022/11/close.svg" alt="">
                </div>
            </div>
            <div class="cs-offerwall__filterOptionsComponentOption" v-on:click="onDefaultOptionClick()" :class="[isDefaultOptionSelected()? 'cs-offerwall__filterOptionsComponentOption--active': '']"> {{dictionary.default}}</div>
            <div class="cs-offerwall__filterOptionsComponentOption"  v-for="option of filterOptions" 
            v-bind:key="option" v-on:click="$emit('clickedFilterOptions',getOptionValue(option), isMultiselect)" 
            :class="[selectedFilters.includes(getOptionValue(option)) ? 'cs-offerwall__filterOptionsComponentOption--active': '']">
                {{ getOptionName(option) }}
            </div>
            <div class="cs-offerwall__filterOptionsComponentOption"></div>
        </div>
        
        <div class="cs-offerwall__filterOptionsComponentBoxBG" v-on:click="onClickedFilterOptionsBG()"></div>
    </div>
</template>

<script>
export default{
    name: 'OfferWallFilterOptionsComponent',
    props: [
        "filterOptions", "dictionary", "showFilterOptions", "isMultiselect", "selectedFilters"
    ],
    emits: [
        "closeFilterOptionsComponent",
        "resetFilters",
        "clickedFilterOptions",
    ],
    data: function(){
        return {
        }
    },
    methods: {
        getOptionName(option){
            return option.name ? this.dictionary[option.name] : this.dictionary[option];
        },
        getOptionValue(option){
            return option.name ? option.name : option;
        },
        onDefaultOptionClick(){
            this.$emit("resetFilters");
            if(!this.isMultiselect){
                this.$emit("closeFilterOptionsComponent");
            }
        },
        isDefaultOptionSelected(){
            return this.selectedFilters.length == 0;
        },
        onClickedFilterOptionsBG(){
            this.$emit("closeFilterOptionsComponent");
        }
    },
    mounted: function() {
    }
}
</script>

<style lang="scss" scoped>
    .cs-offerwall__filterOptionsComponent{
            position: fixed;   
            bottom: 0;
            left: 0;
            right: 0;
            top: 0;
            z-index: 10;

            @media screen and (min-width: 768px) {
                left: 340px;
            }
        &Box {
            background:white;
            border-radius: 25px 25px 0 0;
            color: #223B5F;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 2;

            &BG{
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                top: 0;
                background: rgba(0, 10, 102, 0.58);
                z-index: 1;
            }

            &Header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 15px;
                height: 45px;
                border-bottom: 3px solid #D9D9D9;
            }

            &Title{
                font-size: 16x;
                font-weight: 700;
            }

            &Close{
                cursor: pointer;
                display: flex;
                align-items: center;
            }
        }

        &Option{
            height:35px;
            border-bottom: 1px solid #D9D9D9;
            display: flex;
            align-items: center;
            padding-left: 15px;
            font-size: 15px;
            font-weight: 500;
            
            &--active{
                color:#0194F4;
                font-weight: 700;
            }
        }
    }
</style>